import { AuthApiError } from "./platform-auth";
import { useAuthStore } from "../stores/auth-store";

type AuthRequiredHandler = (retry: () => void) => void;

let authRequiredHandler: AuthRequiredHandler | null = null;

export function setAuthRequiredHandler(handler: AuthRequiredHandler | null) {
  authRequiredHandler = handler;
}

export function isAuthenticated(): boolean {
  return Boolean(useAuthStore.getState().accessToken);
}

/** Returns true when the action may run immediately; otherwise opens login UI. */
export function requestAuthForAction(action: () => void): boolean {
  if (isAuthenticated()) {
    action();
    return true;
  }
  authRequiredHandler?.(action);
  return false;
}

export function isUnauthorizedError(err: unknown): boolean {
  if (err instanceof AuthApiError && err.status === 401) return true;
  if (err instanceof Error) {
    const msg = err.message;
    return (
      msg.includes("401") ||
      msg.includes("منقضی") ||
      msg.includes("نامعتبر") ||
      msg.includes("توکن احراز هویت") ||
      msg.includes("ارسال نشده") ||
      msg.includes("وارد شوید") ||
      msg.includes("Unauthorized")
    );
  }
  return false;
}

/** Clears stale session and prompts re-login; returns true when handled. */
export function handleApiAuthError(err: unknown, retry: () => void): boolean {
  if (!isUnauthorizedError(err)) return false;
  useAuthStore.getState().clearSession();
  requestAuthForAction(retry);
  return true;
}
